import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
`;

export const CloseIcon = styled.img`
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
`;

// export const Content = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, minmax(0, 1fr));
//   gap: 20px;
//   align-items: start;
// `;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  align-items: start;

  overflow: visible;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-width: 0;

  label {
    font-size: 13px;
    color: #6b6f82;
    font-family: BiotifMedium;
    margin-bottom: 6px;
    line-height: 18px;
  }

  > div,
  > input {
    width: 100%;
  }

  /* Common Input */
  input {
    box-sizing: border-box;
  }

  /* DatePicker wrapper fix */
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    height: 38px;
    border-radius: 7px;
  }
`;

export const FullRow = styled.div`
  grid-column: 1 / -1;

  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
`;

export const SectionTitle = styled.div`
  grid-column: 1 / -1;

  font-size: 14px;
  font-family: BiotifMedium;
  color: #1c1b3a;

  padding-top: 12px;
  margin-top: 4px;

  border-top: 1px solid #e0e3eb;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
`;

// export const SearchDropdown = styled.div`
//   position: absolute;
//   top: calc(100% + 4px);
//   left: 0;
//   width: 100%;

//   z-index: 1000;

//   background: #fff;
//   border: 1px solid #d9dce7;
//   border-radius: 8px;

//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

//   max-height: 220px;
//   overflow-y: auto;

//   overscroll-behavior: contain;
// `;

export const SearchDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;

  z-index: 99999;

  background: #fff;
  border: 1px solid #d9dce7;
  border-radius: 8px;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  max-height: 220px;
  overflow-y: auto;

  position: absolute;
`;

export const SearchItem = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f3f4f8;
  }
`;

export const LoadingText = styled.div`
  padding: 10px 12px;
  font-size: 13px;
  color: #6b6f82;
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  margin-top: 5px;

  /* target internal dropdown container */
  > div {
    height: 38px;
    min-height: 38px;
  }

  /* optional: align text vertically */
  button,
  input,
  div[class*='control'] {
    min-height: 38px;
    height: 38px;
  }
  select {
    min-width: 183px;
  }
`;
